import { render, staticRenderFns } from "./CreateMandateView.vue?vue&type=template&id=3ac2a300&"
import script from "./CreateMandateView.vue?vue&type=script&lang=ts&"
export * from "./CreateMandateView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports